import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  itinerary: null,
  loading: false,
  error: null,
  preferences: {
    startDate: null,
    duration: null,
    interests: [],
    specialRequirements: null,
  },
};

export const plannerSlice = createSlice({
  name: 'planner',
  initialState,
  reducers: {
    setItinerary: (state, action) => {
      state.itinerary = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPreferences: (state, action) => {
      state.preferences = { ...state.preferences, ...action.payload };
    },
  },
});

export const { setItinerary, setLoading, setError, setPreferences } = plannerSlice.actions;

export default plannerSlice.reducer;
